(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["giftera-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function load(el) {
      if (el.dataset.gfRecsLoaded || el.querySelector('[data-gf-recs-content]')) return;
      var url = el.getAttribute('data-url');
      if (!url || !window.fetch) return;
      el.dataset.gfRecsLoaded = 'true';
      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (text) {
          if (!text) return;
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-gf-recs] [data-gf-recs-content]');
          if (!fresh || !fresh.querySelector('.gf-pgrid__item')) return;
          el.appendChild(document.importNode(fresh, true));
          el.hidden = false;
        })
        .catch(function () {});
    }

    function init(scope) {
      var list = (scope || document).querySelectorAll('[data-gf-recs]');
      Array.prototype.forEach.call(list, function (el) {
        if (!('IntersectionObserver' in window)) {
          load(el);
          return;
        }
        /* elementul e ascuns până are conținut, deci se observă învelișul secțiunii */
        var target = el.parentElement || el;
        var io = new IntersectionObserver(
          function (entries) {
            if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
            io.disconnect();
            load(el);
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        io.observe(target);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
